import { SubscriptionUserType } from 'ha/pages/BillingSubscriptionLanding/components/Layout';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { SubscriptionProduct } from './types/Subscriptions';

const getSubscriptionProductsByHandle =
  (makeCall: MakeCall) => (productType: SubscriptionUserType) =>
    makeCall<SubscriptionProduct>(
      'GET',
      `/api/v2/billing/subscriptions/products/${productType}`,
    );

export { getSubscriptionProductsByHandle };
